import { useQuery } from "react-query";
import SkillsReportsService from "./SkillsReportsService";

const useSearchSkillsByName = (query) => {
  return useQuery(
    ["searchSkillsByName", query],
    () => SkillsReportsService.searchSkillsByName(query).then((res) => res.data),
    {
      enabled: !!query,
   
    }
  );
};

export default useSearchSkillsByName;
